import { render, staticRenderFns } from "./rich-editor.vue?vue&type=template&id=1bc84e4c&scoped=true&"
import script from "./rich-editor.vue?vue&type=script&lang=ts&"
export * from "./rich-editor.vue?vue&type=script&lang=ts&"
import style0 from "./rich-editor.vue?vue&type=style&index=0&id=1bc84e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc84e4c",
  null
  
)

export default component.exports